module.exports = __webpack_public_path__ + "img/ekyc_doc_poa_2.51c7221a.svg";